import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { COMMAND_PRIORITY_HIGH, KEY_ESCAPE_COMMAND } from 'lexical'
import { type JSX, useEffect } from 'react'

function CustomFocusPlugin({
    initialState,
    isEditingMode,
    onCancel,
    isDisabled,
}): JSX.Element | null {
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        editor.setEditable(isEditingMode)
        if (isEditingMode) {
            setTimeout(() => {
                editor.focus()
            }, 100)
        }
    }, [editor, isEditingMode])

    useEffect(
        () =>
            editor.registerCommand(
                KEY_ESCAPE_COMMAND,
                () => {
                    if (isDisabled) return

                    editor.update(() => {
                        onCancel(editor, initialState)
                    })

                    return true
                },
                COMMAND_PRIORITY_HIGH,
            ),
        [initialState, editor, onCancel],
    )

    return null
}

export { CustomFocusPlugin }
